import { create } from "zustand"

import { InventoryItem } from "../../../../../types"

interface SendMailModalStore {
  isOpen: boolean
  onOpen: (userId?: number) => void
  onClose: () => void
  selectedChildId: number
  setSelectedChildId: (selectedChild: number) => void
  message: string
  setMessage: (message: string) => void
  selectedGift: InventoryItem | null
  setSelectedGift: (selectedGift: InventoryItem | null) => void
  imagePreviewUrl: string | null
  setImagePreviewUrl: (imagePreviewUrl: string | null) => void
  imageFile: File | null
  setImageFile: (imageFile: File | null) => void
  audioPreviewUrl: string | null
  setAudioPreviewUrl: (audioPreviewUrl: string | null) => void
  audioFile: File | null
  setAudioFile: (audioFile: File | null) => void
}

export const useSendMailModalStore = create<SendMailModalStore>((set) => ({
  isOpen: false,
  onOpen: (userId?: number) => set({ isOpen: true, selectedChildId: userId }),
  onClose: () =>
    set({
      isOpen: false,
      selectedChildId: 0,
      message: "",
      selectedGift: null,
      imagePreviewUrl: null,
      imageFile: null,
      audioPreviewUrl: null,
      audioFile: null,
    }),
  selectedChildId: 0,
  setSelectedChildId: (selectedChildId) => set({ selectedChildId }),
  message: "",
  setMessage: (message) => set({ message }),
  selectedGift: null,
  setSelectedGift: (selectedGift) => set({ selectedGift }),
  imagePreviewUrl: null,
  setImagePreviewUrl: (imagePreviewUrl) => set({ imagePreviewUrl }),
  imageFile: null,
  setImageFile: (imageFile) => set({ imageFile }),
  audioPreviewUrl: null,
  setAudioPreviewUrl: (audioPreviewUrl) => set({ audioPreviewUrl }),
  audioFile: null,
  setAudioFile: (audioFile) => set({ audioFile }),
}))
